import { useBrand } from '../../contexts/BrandContext';
import { useToast } from '../../contexts/ToastContext';
import { useStartConversation, useUserConversation } from '../../queries/supportChat';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Spinner } from '../../components/ui/Spinner';
import { ConversationThread, canReply } from '../CustomerMessages/ConversationThread';

/** The member's chat with the team, or a way to start one so staff can write first. */
export function UserMessagesTab({ userId }: { userId: number }) {
  const { role } = useBrand();
  const { data, isLoading } = useUserConversation(userId);
  const start = useStartConversation();
  const toast = useToast();

  if (isLoading) return <Spinner label="Loading messages…" />;

  if (!data?.conversationId) {
    return (
      <Card className="p-6 text-sm">
        <p className="text-muted-foreground">This member hasn't used the chat yet.</p>
        <p className="mt-1 text-muted-foreground">
          They'll only see a message if the Customer Chat feature is on for them (Features).
        </p>
        {canReply(role) && (
          <Button
            className="mt-4"
            size="sm"
            disabled={start.isPending}
            onClick={() => start.mutate(userId, { onError: () => toast.error("Couldn't start the conversation.") })}
          >
            Start a conversation
          </Button>
        )}
      </Card>
    );
  }

  return (
    <Card className="overflow-hidden p-0">
      <ConversationThread conversationId={data.conversationId} compact />
    </Card>
  );
}
